<template>
  <transition name="fade">
    <div class="modal" v-if="show" v-on:click.stop="modalClicked">
      <div class="modalOverlay"></div>
      <div class="modalContent">
        <h4 v-html="title"></h4>
        <p v-html="desc"></p>
        <form v-on:submit.prevent="close(true)">
          <div class="fieldGroup" v-for="(item, i) in inputs" :key="`inpt${i}`"
            :class="{hasError: item.error}">
            <label v-if="item.label && !['toggle', 'checkbox'].includes(item.type) && item.label">
              {{item.label}}
            </label>
            <textarea :rows="item.type === 'textarea' ? 5 : 2"
              class="field" :placeholder="item.placeholder || item.label"
              v-model="item.value" ref="inputs"
              v-if="['longtext', 'textarea', 'long-textarea'].includes(item.type)"
              v-on:input="item.error = null"></textarea>
            <select class="field" v-model="item.value" v-else-if="item.type === 'select'">
              <option v-for="(option, i2) in item.options" :key="`opt${i2}`"
                :value="option">{{option}}</option>
            </select>
            <div class="toggle" v-else-if="item.type === 'toggle'">
              <div class="radioItem" :class="{on: item.value}"
                v-on:click="item.value = !item.value; item.error = null">
                <div class="radioIn">
                  <div class="radioHandle"></div>
                </div>
                {{item.label}}
              </div>
            </div>
            <div class="checkCnt" v-else-if="item.type === 'checkbox'"
              v-on:click="item.value = !item.value">
              <div class="checkboxOuter">
                <div class="checkbox" :class="{checked: item.value}">
                  <div class="checkInner"></div>
                </div>
              </div>
              <p>{{item.lable}}</p>
            </div>
            <input :type="item.type" class="field" v-else-if="['date', 'datetime-local'].includes(item.type)"
              v-model="item.value" ref="inputs" v-on:input="item.error = null">
            <input :type="item.type" class="field" :placeholder="item.placeholder || item.label"
              v-model="item.value" ref="inputs" v-else v-on:input="item.error = null">
            <div class="fieldHint" v-if="item.helper || item.hint">{{item.helper || item.hint}}</div>
            <div class="fieldError" :class="{toggleError: item.type === 'toggle'}"
              v-if="item.error">{{item.error}}</div>
          </div>
        </form>
        <div class="modalAction" v-if="error">
          <button class="btn btnSecondary" v-on:click="close(false)"
            ref="btnPrimary">
            <span v-if="action">{{action}}</span>
            <span v-else>Close</span>
          </button>
        </div>
        <div class="modalAction" v-else>
          <div class="langSelectorBtn" v-if="multiLang"
            v-on:click.stop="langSelectorOpen = !langSelectorOpen">
            <b>{{lang}}</b>
            <div class="langSelector" v-if="langSelectorOpen"
              v-on:click.stop="doNothing">
              <li v-on:click.stop="selectLang('en')">EN - English</li>
              <li v-on:click.stop="selectLang('id')">ID - Bahasa Indonesia</li>
            </div>
          </div>
          <button class="btn btnSecondary" v-on:click="close(false)">Cancel</button>
          <button class="btn btnPrimary" v-on:click="close(true)" ref="btnPrimary">
            <span v-if="action">{{action}}</span>
            <span v-else>Delete</span>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'confirmation',
  data() {
    return {
      show: false,
      title: '',
      desc: '',
      action: '',
      inputs: [],
      next: null,
      error: false,
      multiLang: false,
      lang: 'id',
      langSelectorOpen: false,
    };
  },
  methods: {
    modalClicked() {
      this.langSelectorOpen = false;
    },
    keyPressed(e) {
      if (!this.show) return;
      if (e.key === 'Escape') {
        this.close(false);
      }
    },
    selectLang(lang) {
      this.langSelectorOpen = false;
      this.lang = lang;
    },
    open(d, next) {
      this.show = true;
      this.next = next;
      this.title = d.title;
      this.desc = d.desc;
      this.action = d.action;
      this.error = d.error;
      this.inputs = d.inputs || [];
      this.multiLang = d.multiLang;
      this.lang = d.lang || 'id';
      setTimeout(() => {
        if (this.inputs.length > 0 && this.$refs.inputs) {
          if (this.$refs.inputs[0]) this.$refs.inputs[0].focus();
        } else {
          this.$refs.btnPrimary.focus();
        }
      });
    },
    close(b) {
      /**
       * Validate input
       *
       */
      if (b && this.inputs && this.inputs.length > 0) {
        // eslint-disable-next-line
        for (const item of this.inputs) {
          if (item.required && !item.value) {
            if (['select', 'toggle'].includes(item.type)) item.error = `Please select ${item.label}`;
            else item.error = `Please input ${item.label}`;
            return;
          }
          if (item.type === 'email' && item.value) {
            // eslint-disable-next-line
            const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
            if (!item.value.trim().toLowerCase().match(re)) {
              item.error = 'Email address not valid';
              return;
            }
          }
        }
      }

      this.show = false;
      const inputs = this.inputs ? JSON.parse(JSON.stringify(this.inputs)) : null;
      if (this.next) this.next(b, inputs);
    },
  },
  created() { window.addEventListener('keydown', this.keyPressed); },
  destroyed() { window.removeEventListener('keydown', this.keyPressed); },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 40px;
      border-radius: 5px;
      margin-top: -20px;
      // text-align: center;
      overflow: hidden;
      width: 320px;
      h4{
        margin: 0;
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 5px;
        color: #444;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      p{
        margin: 0;
        color: #767676;
      }
      .fieldGroup{
        margin: 20px 0 0;
      }
      .modalAction{
        margin: 30px -40px -30px;
        padding: 10px 20px;
        text-align: right;
        display: flex;
        align-items: center;
        .langSelectorBtn{
          margin-right: auto;
          position: relative;
          border-radius: 50px;
          padding: 6px 16px;
          padding-left: 36px;
          transition: all .3s ease;
          cursor: pointer;
          &:hover{
            background-color: #f5f5fe;
          }
          &:before{
            content: "";
            position: absolute;
            left: 12px; top: 0; bottom: 3px;
            width: 18px;
            background-image: url(../assets/language.png);
            background-size: 18px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          b{
            font-weight: 600;
            text-transform: uppercase;
          }
          .langSelector{
            position: absolute;
            background-color: #fff;
            z-index: 7;
            bottom: 100%; left: 0;
            box-shadow: 0 0 6px rgba(0, 0, 0, .2);
            border-radius: 5px;
            padding: 8px 0;
            text-align: left;
            li{
              white-space: nowrap;
              list-style: none;
              padding: 8px 24px;
              cursor: pointer;
              transition: all .3s ease;
              &:hover{
                background-color: #f5f5fe;
              }
            }
          }
        }
        .btn{
          margin-left: 10px;
          &.btnSecondary{
            margin-left: auto;
          }
        }
      }
    }
  }
</style>
